import { render, staticRenderFns } from "./AddCompanyDialog.vue?vue&type=template&id=1e23d570&scoped=true"
import script from "./AddCompanyDialog.vue?vue&type=script&lang=js"
export * from "./AddCompanyDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCompanyDialog.vue?vue&type=style&index=0&id=1e23d570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23d570",
  null
  
)

export default component.exports